import kaplay from "kaplay";
import inizio from "./inizio.js";
import sconfitta from "./sconfitta.js";
import vittoria from "./vittoria.js";
import primoLivello from "./primoLivello.js";
import secondoLivello from "./secondoLivello.js";
import terzoLivello from "./terzoLivello.js"
import quartoLivello from "./quartoLivello.js"
import quintoLivello from "./quintoLivello.js";
import ultimoLivello from "./ultimoLivello.js";
import classifica from "./classifica.js";
import { resetPunteggio, addButton, getPunteggio } from "./utility.js";

const k = kaplay({
    width: 1280,
    height: 720,
    stretch: true,
    letterbox: true,
    background: [0, 0, 0],
    debug: true,
});

k.loadRoot("./");
k.loadSprite("pando", "/sprites/pando.png");
k.loadSprite("bamboo", "/sprites/bamboo.png");
k.loadSprite("bambooninja", "/sprites/bamboo_ninja.png");
k.loadSprite("grass", "/sprites/grass.png");
k.loadSprite("ghosty", "/sprites/ghosty.png");
k.loadSprite("portal", "/sprites/portal.png");
k.loadSprite("maiale", "/sprites/maiale.png");
k.loadSprite("boss", "/sprites/boss.png");
k.loadSprite("heart", "/sprites/heart.png");
k.loadSprite("lightening", "/sprites/lightening.png");
k.loadSprite("sfondo","/sprites/sfondo.png");
k.loadSound("ginu","/sounds/blitz.mp3");
k.loadSound("score", "/sounds/score.mp3");
k.loadSound("portal", "/sounds/portal.mp3");
k.loadSound("pericolo", "/sounds/mystic.mp3")
inizio(k);
sconfitta(k);
vittoria(k);
primoLivello(k);
secondoLivello(k);
terzoLivello(k);
quartoLivello(k);
quintoLivello(k);
ultimoLivello(k);
classifica(k);
k.layers(["bg", "game", "ui"], "game");
k.go("inizio");